import * as React from "react";
import { Layout } from "../../layout";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";

const CreditsRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org} showLeftMenu={false}>
      <div>
        <div className="mb-8">Credits</div>
        <div className="mb-4">Icons</div>
        <div className="flex flex-col gap-1">
          <a href="https://www.flaticon.com/free-icons/ui-design" title="ui design icons" target={"_blank"}>
            Ui design icons created by paonkz - Flaticon
          </a>
          <a href="https://www.flaticon.com/free-icons/app-store" title="app store icons" target={"_blank"}>
            App store icons created by juicy_fish - Flaticon
          </a>
          <a href="https://www.flaticon.com/free-icons/ip-address" title="ip address icons">
            Ip address icons created by Freepik - Flaticon
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default CreditsRoute;
